import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
// import { RoutePath } from '../../../routes/Routes'
import StateComponents from '../../../components/state-component/StateComponents'
import { icons } from '../../../assets/icons/icons'
import { ManageState } from './manageState'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../utils/app.utils'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { banner_type_data, content_news_status_data } from '../website-structure/content/enum/content.enum'

import 'react-image-crop/dist/ReactCrop.css'
import { routeName } from '../../../routes/routeName'
import { useTranslation } from 'react-i18next'



type Props = {}

const ContentNews: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        checkPermit,
        category_data,
        id_category,
        set_id_category,
        set_content_status_name,
        content_status_name
    } = ManageState();



    return (
        <ContainerLayout
            titleName={t('ข่าวประชาสัมพันธ์')}
            title=''
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์", // i18n-ignore
                                name: t("โครงสร้างเว็บไซต์"),
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "content_news",
                                name: t("ข่าวประชาสัมพันธ์"),
                                pathName: routeName.cms_website.content_news,
                            },
                        ]}
                />
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        otherProps={{
                            spacing: 2
                        }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 2.5
                                },
                                fieldProps: {
                                    startAdornment: <span className='mr-4'><icons.SearchNormal /></span>,
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    placeholder: t("ค้นหาชื่อ"),
                                }
                            },
                            {
                                seq: 2,
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 2.5
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => op?.category_name || "",
                                    labelId: "banner_type",
                                    placeholder: t('ทุกหมวดหมู่'),
                                    onChange: (_, val) => set_id_category(val?.id_category ?? null),
                                    options: category_data || [],
                                    value: category_data?.find((x) => x?.id_category === id_category) || null
                                }
                            },
                            {
                                seq: 3,
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 2.5
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => t(op?.label ?? ""),
                                    labelId: "banner_type",
                                    placeholder: t('ทุกสถานะข่าว'),
                                    onChange: (_, val) => set_content_status_name(val?.value),
                                    options: content_news_status_data || [],
                                    value: content_news_status_data?.find((x) => x.value === content_status_name) || null
                                }
                            },
                            {
                                seq: 4,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 2.5
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    value: {
                                        end_date: endDate,
                                        start_date: startDate
                                    },
                                    placeholder: t("ช่วงวันที่"),
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    md: 2
                                },
                                hidden: !checkPermit.isCreated,
                                fieldProps: {
                                    justifyContent: 'flex-end',
                                    buttonData: [
                                        {
                                            seq: 1,
                                            buttonProps: {
                                                onClick: () => navigate(routeName.cms_website.content_news_create)
                                            },
                                            key: "ADD",
                                            label: t("เพิ่มข่าว"),
                                            type: "ADD"
                                        }
                                    ]
                                }
                            },
                        ]}
                    />

                    <section className='w-full mt-10'>
                        <TableCustom
                            tableMinWidth={1920}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCell}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </div>
            }
        />
    )
}

export default ContentNews